import * as actionTypes from "actions/actionTypes/snackbarActionTypes";
import { showEvent } from "actions/actionCreators/snackbarActions";
import initialState from "./initialState";
import { snackbarType } from "constants/snackbarType";
import { errorEvents, warningEvents } from "constants/errorEventTypes";
import snackbarVar from "components/snackbar/snackbarVar";

export default function snackbarReducer(state = initialState.snackbar, action) {
  if (errorEvents.some(e => action.type.indexOf(e) > -1)) {
    const properAction = showEvent(action.event);
    return { ...state, msg: properAction.payload, type: snackbarType.error, correlationId: properAction.correlationId };
  }

  if (warningEvents.some(e => action.type.indexOf(e) > -1)) {
    const properAction = showEvent(action.event);
    return {
      ...state,
      msg: properAction.payload,
      type: snackbarType.warning,
      correlationId: properAction.correlationId
    };
  }

  switch (action.type) {
    case actionTypes.SHOW_SNACKBAR_INFO: {
      snackbarVar({ message: action.payload, type: snackbarType.info, autoDismiss: action.autoDismiss });
      break;
    }

    case actionTypes.SHOW_SNACKBAR_ERROR: {
      snackbarVar({ message: action.payload, type: snackbarType.error, correlationId: action.correlationId });
      break;
    }

    case actionTypes.SHOW_SNACKBAR_WARNING: {
      snackbarVar({ message: action.payload, type: snackbarType.warning, correlationId: action.correlationId });
      break;
    }

    default:
      break;
  }

  return state;
}
